@if (plan) {
  <div
    [attr.data-plan_variation]="plan.plan_variation"
    class="card plan__card plan__card_design"
  >
    <div class="plan-card">
      <div class="highlight-attributes">
        <header
          class="plan__card__header"
          [ngClass]="{
            'with-star-rating': !!plan.star_rating && showStarRating,
          }"
        >
          @switch (!!pdfUrl) {
            @case (true) {
              <h5
                class="plan__card__title t-bold"
                data-test-id="planCardTitleLink"
              >
                <a [href]="pdfUrl" target="_blank">{{
                  plan.display_name || plan.name
                }}</a>
              </h5>
            }
            @default {
              <h5 class="plan__card__title t-bold" data-test-id="planCardTitle">
                {{ plan.display_name || plan.name }}
              </h5>
            }
          }
          @if (!showActions) {
            <div
              class="PlanCard--Mobile"
              (click)="toggleDetails()"
              data-test-id="planCardToggleDetails"
            >
              <i
                class="icon icon--medium"
                data-test-id="planCardChevronRightIcon"
                >chevron_right</i
              >
            </div>
          }

          @if (!!plan.isRecommended) {
            <div class="plan__card__banner plan__card__banner--primary">
              <i
                class="icon icon--small"
                data-test-id="planCardThumbUpActiveIcon"
                >thumb_up_active</i
              >
              <p
                class="t-caption t-bold"
                data-test-id="planCardRecommendedLabel"
              >
                Recommended
              </p>
            </div>
          }

          @if (!!plan.isGood) {
            <div class="plan__card__banner">
              <p
                class="t-caption t-bold"
                [innerHTML]="goodFitMessage"
                data-test-id="planCardGoodFitMessage"
              ></p>
            </div>
          }

          @if (
            !showRemovePlanIcon
              ? showRemovePlanIcon
              : !!planDetailConfigs?.showRemovePlanIcon
          ) {
            <icon
              role="button"
              class="RemovePlan"
              [name]="planDetailConfigs?.removePlanIcon || 'delete'"
              [config]="removePlanIconConfig"
              [attr.aria-label]="removePlanIconConfig.ariaLabel"
              (click)="removePlanIconClicked.emit(plan)"
              data-test-id="planCardRemovePlanIcon"
            ></icon>
          }

          @if (!!showActions) {
            <icon
              role="button"
              class="ViewPlanDetails--Mobile"
              name="chevron_right"
              [config]="viewPlanDetailsIconConfig"
              [attr.aria-label]="viewPlanDetailsIconConfig.ariaLabel"
              (click)="toggleDetailsModal()"
              data-test-id="planCardViewDetailsMobileIcon"
            ></icon>
          }
        </header>

        @if (!!plan.star_rating && showStarRating) {
          <section class="plan__card__rating">
            <star-rating
              [starIcon]="
                starRatingConfig?.starIcon ? starRatingConfig.starIcon : 'star'
              "
              [starFilledIcon]="
                starRatingConfig?.starFilledIcon
                  ? starRatingConfig.starFilledIcon
                  : 'star_active'
              "
              [rating]="plan.star_rating"
              data-test-id="planCardStarRatings"
            ></star-rating>
          </section>
        }

        @if (plan.plan_marketing_description) {
          <section
            class="PlanCard__Description"
            data-test-id="planCardDescription"
          >
            <p
              class="t-data"
              [innerHTML]="plan.plan_marketing_description"
              data-test-id="planCardMarketingDescription"
            ></p>
          </section>
        }

        @if (getNoteForOMNIAPlan) {
          <section class="plan__card__note">
            <small
              class="t-data t-alt"
              [innerHTML]="getNoteForOMNIAPlan"
              data-test-id="planCardOmniaPlanNote"
            ></small>
          </section>
        }

        <div
          class="PlanCard__OriginalPriceContent PlanCard__OriginalPriceContent--Mobile"
        >
          <ng-container *ngTemplateOutlet="originalPrice"></ng-container>
        </div>

        @if (!hideHighlights && highlightAttributesFormatted) {
          <section class="PlanCard__Prices">
            @for (highlight of highlightAttributes; track highlight) {
              <ng-container class="PlanCard__Price">
                @if (!!highlight.prop && highlight.prop !== 'price') {
                  <div class="value-wrap">
                    <h5
                      class="PlanCard__PriceHeader"
                      data-test-id="planCardPriceHeader"
                      [innerHTML]="highlight.value"
                    ></h5>
                    <p
                      class="t-data t-alt"
                      [innerHTML]="highlight.label"
                      data-test-id="planCardHighlightLabel"
                    ></p>
                  </div>
                }
              </ng-container>
            }
          </section>
        }

        @if (plan.primary_benefits && showPrimaryBenefits) {
          <section class="PlanCard__Benefits">
            @for (benefit of primaryBenefits; track benefit; let i = $index) {
              <div class="plan__card__benefit">
                <p
                  class="t-data t-bold"
                  [innerHTML]="benefit.label"
                  [attr.data-test-id]="'planCardBenefitLabel' + i"
                ></p>
                <p
                  class="t-data"
                  [innerHTML]="benefit.value"
                  [attr.data-test-id]="'planCardBenefitValue' + i"
                ></p>
              </div>
            }
          </section>
        }

        <ng-container>
          @if (badges) {
            <div class="plan-card__badges">
              @for (badge of badges; track badge) {
                <plan-card-badge
                  [badge]="badge"
                  [attr.data-test-id]="'planCardBadge-' + badge.title"
                ></plan-card-badge>
              }
            </div>
          }
        </ng-container>
      </div>
      <div
        class="PlanCard__OriginalPriceContent PlanCard__OriginalPriceContent--Desktop"
      >
        <ng-container *ngTemplateOutlet="originalPrice"></ng-container>
      </div>
    </div>

    @if (!!showActions) {
      <plan-card-footer
        class="PlanCard__Footer"
        data-test-id="planCardFooter"
        [showActions]="showActions"
        [showDetails]="showDetails"
        [hideSelection]="hideSelection"
        [canCompare]="canCompare"
        [isCompareLocked]="isCompareLocked"
        [isCompareDisabled]="isCompareDisabled"
        [isSelectDisabled]="isSelectDisabled"
        [viewDetailConfig]="viewDetailConfig"
        [plan]="plan"
        [compareTitle]="compareTitle"
        [customButton]="customButton"
        [selectedButtonConfig]="selectedButtonConfig"
        [selectButtonConfig]="selectButtonConfig"
        (toggleDetails)="toggleDetails()"
        (toggleComparison)="toggleComparison()"
        (customButtonClicked)="customButtonClicked.emit()"
        (toggleSelection)="toggleSelection()"
      ></plan-card-footer>
    }

    @if (!!showDetails) {
      <section class="plan__card__panel" @slideRight>
        <header class="plan__card__panel__header">
          <i
            class="icon icon--medium icon--pointer"
            (click)="showDetails = false"
            data-test-id="planCardPanelArrowLeft"
          >
            arrow_left
          </i>
          <p class="t-bold" data-test-id="planCardDisplayName">
            {{ plan.display_name || plan.name }}
          </p>
        </header>

        <main class="plan__card__panel__body">
          <div class="plan__card__attributes">
            @if (!!plan.isRecommended || !!plan.isGood) {
              <section class="plan__card__panel__recommended">
                @if (!!plan.isRecommended) {
                  <div class="chip chip--1">
                    <p
                      class="t-caption t-bold"
                      data-test-id="planCardRecommended"
                    >
                      Recommended
                    </p>
                  </div>
                }

                @if (!!plan.isGood) {
                  <div class="chip chip--3">
                    <p class="t-caption t-bold" data-test-id="planCardGoodFit">
                      Good Fit
                    </p>
                  </div>
                }

                <p
                  class="t-caption"
                  data-test-id="planCardRecommendedDescription"
                >
                  Recommended based on your high pharmacy utilization.
                </p>
              </section>
            }

            @for (benefit of plan.formattedBenefits; track benefit) {
              <div class="plan__card__attribute">
                <p class="t-data t-bold">{{ benefit.label }}</p>

                @if (benefit.type !== 'link') {
                  <p class="t-data" [innerHTML]="benefit.value"></p>
                } @else {
                  <ng-container *ngTemplateOutlet="benefitLink"></ng-container>
                }

                <ng-template #benefitLink>
                  <a
                    class="t-data t-link"
                    target="_blank"
                    [attr.href]="benefit.value"
                    [attr.data-test-id]="'planCardBenefitLink-' + benefit.label"
                  >
                    View Link
                  </a>
                </ng-template>
              </div>
            }
          </div>

          @if (planDetailConfigs?.showLinks || showLinks) {
            <div class="plan__card__links" data-test-id="planCardLinksSection">
              <ng-container *ngTemplateOutlet="planLinkTemplate"></ng-container>
            </div>
          }
        </main>
      </section>
    }

    @if (!!showDetails) {
      <section class="plan__card__details" @accordion>
        <div class="plan__card__detail-columns">
          <div class="plan__card__attributes">
            @for (
              benefit of plan.formattedBenefits;
              track benefit;
              let i = $index
            ) {
              <div class="plan__card__attribute">
                <p
                  class="t-data t-bold"
                  [attr.data-test-id]="'planCardDetailBenefit-' + i"
                >
                  {{ benefit.label }}
                </p>
                @if (benefit.type !== 'link') {
                  <p
                    class="t-data"
                    [innerHTML]="benefit.value"
                    [attr.data-test-id]="'planCardDetailBenefitValue-' + i"
                  ></p>
                } @else {
                  <ng-container *ngTemplateOutlet="benefitLink"></ng-container>
                }

                <ng-template #benefitLink>
                  <a
                    class="t-data t-link"
                    target="_blank"
                    [attr.href]="benefit.value"
                    (click)="linkClicked(benefit, true)"
                    [attr.data-test-id]="'planCardDetailBenefitLink' + i"
                  >
                    {{ planBenefitLinkLabelMap[benefit.label] || 'View Link' }}
                  </a>
                </ng-template>
              </div>
            }
          </div>

          @if (planDetailConfigs?.showLinks || showLinks) {
            <div
              class="plan__card__links"
              data-test-id="planCardLinksInDetails"
            >
              <ng-container *ngTemplateOutlet="planLinkTemplate"></ng-container>
            </div>
          }
        </div>
        @if (
          planDetailConfigs?.displayAllDocuments ||
          planDetailConfigs?.displayDocuments
        ) {
          <div>
            <div class="PlanCard__Pdf">
              @for (document of documentList; track document; let i = $index) {
                <div>
                  <a
                    class="PlanCard__DocumentLink"
                    [href]="document.document_id"
                    target="_blank"
                    [attr.data-test-id]="'planCardDocumentLink-' + i"
                  >
                    <icon
                      name="pdf"
                      [config]="{ type: 'link' }"
                      [attr.data-test-id]="'planCardPdfIcon' + i"
                    ></icon>
                    <span
                      class="t-data t-bold"
                      [attr.data-test-id]="'planCardDocumentLabel-' + i"
                    >
                      {{ document.label || formatDocumentName(document.type) }}
                    </span>
                  </a>
                </div>
              }
            </div>
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="showSinglePdf"></ng-container>
        }
        <ng-template #showSinglePdf>
          @if (!!pdfUrl) {
            <div class="PlanCard__Pdf">
              <a
                class="PlanCard__DocumentLink"
                [href]="pdfUrl"
                target="_blank"
                data-test-id="planCardDocumentLinkSinglePdf"
              >
                <icon
                  name="pdf"
                  [config]="{ type: 'link' }"
                  data-test-id="planCardDocIconSinglePdf"
                ></icon>
                <span
                  class="t-data t-bold"
                  data-test-id="planCardDisplayNameSinglePdf"
                >
                  All {{ plan.display_name }} Benefits
                </span>
              </a>
            </div>
          }
        </ng-template>
      </section>
    }
  </div>
}

<ng-template #planLinkTemplate>
  @if (plan.links) {
    <ng-container *ngTemplateOutlet="dataLinksTemplate"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="configLinksTemplate"></ng-container>
  }

  <ng-template #dataLinksTemplate>
    @for (link of plan.links; track link; let i = $index) {
      <div class="plan__card__link">
        <i
          class="icon icon--medium icon--link"
          [attr.data-test-id]="'planCardDetailsLinkIcon' + i"
          >{{ link.icon }}</i
        >
        <a
          class="t-data t-bold"
          target="_blank"
          [attr.href]="link.url"
          (click)="linkClicked(link)"
          [attr.data-test-id]="'planCardDetailsLink-' + i"
        >
          {{ link.label }}
        </a>
      </div>
    }
  </ng-template>

  <ng-template #configLinksTemplate>
    @if (planDetailConfigs?.summary_benefits) {
      <div class="plan__card__link">
        <i
          class="icon icon--medium icon--link"
          data-test-id="plancardConFigLinkPdf"
          >pdf</i
        >
        <a
          class="t-data t-bold"
          target="_blank"
          [attr.href]="planDetailConfigs?.summary_benefits.link"
          (click)="linkClicked(link)"
          [attr.data-test-id]="'planCardSummaryBenefits'"
        >
          {{ planDetailConfigs?.summary_benefits?.label || 'See All Benefits' }}
        </a>
      </div>
    }

    @if (planDetailConfigs.find_doctor) {
      <div class="plan__card__link">
        <i
          class="icon icon--small icon--link"
          data-test-id="planCardFindDoctorIcon"
          >{{ planDetailConfigs.find_doctor?.icon || 'doctors' }}</i
        >
        <a
          class="t-data t-bold"
          target="_blank"
          [attr.href]="planDetailConfigs.find_doctor?.link"
          (click)="linkClicked(link)"
          [attr.data-test-id]="'planCardFindDoctor'"
        >
          {{ planDetailConfigs.find_doctor?.label || 'Find a Doctor' }}
        </a>
      </div>
    }

    @if (planDetailConfigs.links) {
      <div>
        @for (link of planDetailConfigs.links; track link; let i = $index) {
          <div class="plan__card__link">
            @if (link.modal) {
              <a
                class="t-data t-bold"
                target="_blank"
                (click)="modalAction('display', link)"
                [attr.data-test-id]="'planCardConfigLinkModal-' + i"
              >
                <i
                  class="icon icon--medium icon--link"
                  [attr.data-test-id]="'planCardConfigLinkICon' + i"
                  >{{ link.icon || 'person' }}</i
                >
                {{ link.label || 'Find a Provider' }}
              </a>
            } @else {
              <ng-container *ngTemplateOutlet="normalLink"></ng-container>
            }
            <ng-template #normalLink>
              <a
                class="t-data t-bold"
                target="_blank"
                [attr.href]="link.link"
                [attr.data-test-id]="'planCardConfigLinkNormalAnchor-' + i"
              >
                <i
                  class="icon icon--medium icon--link"
                  [attr.data-test-id]="'planCardConfigLinkNormalAnchor' + i"
                  >{{ link.icon || 'person' }}</i
                >
                {{ link.label || 'Find a Provider' }}
              </a>
            </ng-template>
          </div>
        }
      </div>
    }
  </ng-template>
</ng-template>

<ng-template #originalPrice>
  <div class="PlanCard__Premium">
    <h5
      class="t-bold PlanCard__PremiumHeader"
      data-test-id="planCardPremiumHeader"
      [innerHTML]="
        useDiscountedPrice
          ? originalPriceObj.discountedPrice
          : originalPriceObj?.value
      "
    ></h5>
    <p
      class="t-data t-alt"
      [innerHTML]="originalPriceObj?.label"
      data-test-id="planCardPremiumPriceLabel"
    ></p>

    @if (useDiscountedPrice) {
      <div>
        <p
          class="t-bold"
          [innerHTML]="subsidyTextConfig.subsidyLabel"
          data-test-id="planCardSubsidyLabel"
        ></p>
        <p
          class="t-data t-alt"
          [innerHTML]="subsidyTextConfig.originalPriceLabel"
          data-test-id="planCardSubsidyPriceLabel"
        ></p>
      </div>
    }
  </div>
</ng-template>

@if (plan && showViewDetailsModal) {
  <view-details-modal
    [viewDetailsModalConfig]="viewDetailsModalConfig"
    [plan]="plan"
    [planDetailConfigs]="planDetailConfigs"
    [documentList]="documentList"
    (toggleDetailsModal)="toggleDetailsModal()"
    data-test-id="planCardViewDetailsModal"
  ></view-details-modal>
}

<modal
  class="PlanCardModal"
  [config]="textPopUpModalConfig"
  [condition]="displayModal"
  (cancel)="modalAction('close')"
  data-test-id="planCardModal"
>
  <div body>
    @for (
      paragraph of modalContent?.paragraphs;
      track paragraph;
      let i = $index
    ) {
      <div
        class="Modal__Body--PrimaryText"
        [attr.data-test-id]="'planCardModalParagraph-' + i"
      >
        {{ paragraph }}
      </div>
    }
  </div>
  <div footer>
    <zip-button
      class="Modal__Footer--CloseButton"
      [config]="modalContent?.buttons?.close"
      (zipButtonClicked)="modalAction('close')"
      data-test-id="planCardModalCloseButton"
    >
    </zip-button>
    <zip-button
      class="Modal__Footer--OpenButton"
      [config]="modalContent?.buttons?.open"
      (zipButtonClicked)="modalAction('open')"
      data-test-id="planCardModalOpenButton"
    >
    </zip-button>
  </div>
</modal>
